import { map, get, flow } from 'lodash/fp';
import { createSelector, createStructuredSelector } from 'reselect';
import { formatDistance } from 'helpers/i18n';
import { getMinMaxOptions } from 'helpers/fieldOptions';
import { options as mileageOptions } from 'helpers/fieldOptions/car/mileage';

const getOptions = createSelector(
  createStructuredSelector({
    options: () => mileageOptions,
    compareValue: get(['compareValue']),
    type: get(['rangeType']),
  }),
  flow(
    ({ options, compareValue, type }) =>
      type ? getMinMaxOptions({ options, compareValue, type }) : options,
    map((item) => ({ ...item, label: formatDistance(item.label) })),
  ),
);

export default {
  clearable: () => true,
  options: getOptions,
  placeholder: () => __('search.filters.any'),
};
